import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { SetupComponent } from './setup.component';
import { SharedModule } from '../shared/shared.module';

const setupRoutes: Routes = [
    {
    path: 'image',
    component: SetupComponent
    }
];

@NgModule({
  declarations: [
    SetupComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    SharedModule,
    RouterModule.forChild(setupRoutes)
  ],
  bootstrap: [
    SetupComponent
  ],
  exports: [
    SetupComponent  
  ]
})

export class SetupModule {}